import React from 'react';
import { ReactComponent as Expired } from 'assets/icons/eiq-connect/expired.svg';
import { Tag } from 'antd';
import { GuestType } from '../../enums/guest-type.enum';
import { IGuestRead } from '../../services/residents-service/residents.service.types';
import { getGuestTypeValue } from 'common/helpers/guest-type.helpers';

export const guestTypeColorMap: Record<GuestType, string> = {
  [GuestType.Undefined]: '#DCDCDC',
  [GuestType.Family]: '#C1FFEA',
  [GuestType.Service]: '#D1E3FF',
  [GuestType.RideShare]: '#FFD889',
  [GuestType.Delivery]: '#FFD889',
  [GuestType.Guest]: '#EECAFF',
  [GuestType.UrgentService]: '#D1E3FF',
  [GuestType.Employee]: '#ffd1ee',
  [GuestType.Medical]: '#D1E3FF',
};

export const getGuestTypeTag = (rowData: IGuestRead) => {
  const { type, expiredAt } = rowData;

  if (expiredAt) {
    return (
      <Tag className="eiq-tag expired" icon={<Expired />}>
        {getGuestTypeValue(type)}
      </Tag>
    );
  } else {
    return (
      <Tag className="eiq-tag" color={guestTypeColorMap[type as GuestType]} style={{ color: '#292B2E' }}>
        {getGuestTypeValue(type)}
      </Tag>
    );
  }
};
